import { ThemedBankManagement as BankManagement } from './bank-management';
export const ThemedBankManagement = BankManagement;
